<template>
  <div>
    <b-container class="container-panel">
      <b-row align-v="end">
        <b-col cols="4">
          <img src="./assets/images/logoSmall.jpg"
               class="logo-margin"
               alt="Ambit Cares Logo"
               aria-label="Ambit Cares Logo" />
        </b-col>
        <b-col cols="8">
          <span class="page-title align-center">Thank you for your donation</span>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="container-panel outlined-panel">
      <b-row>
        <b-col class="container-panel-heading">
          Receipt
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="1"></b-col>
        <b-col cols="10"
               class="align-left receipt-note">
          No goods or services were exchanged for this contribution. All gifts may be tax-deductible to the extent allowed by law.
          Ambit Cares, Inc. is an exempt organization as described in Section 501(c)(3) of the Internal Revenue Code, EIN 81-2832542.
          <br />
          Please print this page for your records.
          <span v-if="showEmailMessage">
            <br /><i>A receipt has alse been emailed to the address you provided.</i>
          </span>
        </b-col>
        <b-col cols="1"></b-col>
      </b-row>

      <b-form>
        <b-container fluid>
          <b-table
                   id="receiptInfoTable"
                   name="receiptInfoTable"
                   class="align-left receipt-table"
                   striped
                   hover
                   :items="receiptInfo"
                   >
          </b-table>
        </b-container>
      </b-form>
    </b-container>

    <b-container class="container-panel">
      <b-row align-v="end">
        <b-col cols="6">
        </b-col>
        <b-col cols="6">
          <b-button class="btn btn-primary btn-lg btn-margin-narrow-aligned-right float-right"
                    title="Print the form"
                    aria-label="Print the form"
                    @click="printForm">
            Print this for your records
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    name: 'Receipt',
    data() {
      return {
        fields: ['info', 'data'],
        receiptInfo: [],
        receiptObject: {
          donorType: '',
          donorNumber: '',
          donorFullName: '',
          billingFullName: '',
          creditCardNumberMasked: '',
          creditCardTransactionDate: '',
          creditCardAmount: 0.0,
          emailAddress: '',
          creditCardTransactionID: '',
          creditCardTransactionStatus: '',
          creditCardReferenceNumber: '',
        },
        showEmailMessage: false,
      };
    },

    // -----------------------------------------------------------------------
    // The created method is part of the Vue.js lifecycle.
    // It gets called as the page is created.
    // It fetches data from the Vuex store (placed there by the "NormalDonation"
    // page and uses that data to populate the 
    // page variables used to display the receipt info
    // -----------------------------------------------------------------------
    created() {
      const {
        donorType,
        donorNumber,
        donorFullName,
        billingFullName,
        creditCardNumberMasked,
        creditCardAmount,
        creditCardType,
        emailAddress,
        showEmailMessage,
        creditCardTransactionID,
        creditCardTransactionDate,
        creditCardTransactionStatus,
        creditCardReferenceNumber,
      } = this.$store.state.receiptData;

      const dateOptions = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };

      let formattedDate = '';
      if (creditCardTransactionDate) {
        formattedDate = new Date(creditCardTransactionDate).toLocaleDateString('en-US', dateOptions);
      }

      let donorInfo = donorType;
      if (donorNumber) {
        donorInfo += `: ${donorNumber}`;
      }

      this.receiptInfo.push({ info: 'Donor', data: donorFullName });
      this.receiptInfo.push({ info: '', data: donorInfo });
      this.receiptInfo.push({ info: 'Billed To', data: billingFullName });
      this.receiptInfo.push({ info: 'Credit Card', data: creditCardType });
      this.receiptInfo.push({ info: '', data: creditCardNumberMasked });
      this.receiptInfo.push({ info: 'Amount', data: creditCardAmount });
      this.receiptInfo.push({ info: 'Email Address', data: emailAddress });
      this.receiptInfo.push({ info: 'Transaction Date', data: formattedDate });
      this.receiptInfo.push({ info: 'Credit Card Transaction ID', data: creditCardTransactionID });
      this.receiptInfo.push({ info: 'Credit Card Reference Number', data: creditCardReferenceNumber });
      this.receiptInfo.push({ info: 'Credit Card Transaction Status', data: creditCardTransactionStatus });

      this.showEmailMessage = showEmailMessage;
    },

    methods: {
      printForm() {
        window.print();
      },
    },
  }

</script>

<style src="./assets/css/CommonVue.css" scoped>
</style>

<style>
  .receipt-table > thead {
    display: none;
  }
</style>
<style scoped>
</style>
